import FormInfo from '@type/FormInfo';
import NonMatchingParamKey from '@type/NonMatchingParamKey';

//DEBT: Why can't this be imported with @functions without it breaking Cypress?
import isNonMatchingParamKey from '../isNonMatchingParamKey/isNonMatchingParamKey';
import User from '@type/inline/User';

declare let formInfo: FormInfo;

declare let user: User;

type SourceInfo = {
    secondarySource?: string | null;
    cid?: string | null;
    useGeoSpecificCid?: boolean | null;
    pageSource?: FormInfo | null;
    urlParams?: URLSearchParams | null;
    paramKeys?: Array<string | NonMatchingParamKey>;
};

const formSources = (sourceInfo?: SourceInfo): FormInfo => {
    const { secondarySource, cid, pageSource, urlParams, paramKeys } = {
        ...sourceInfo,
    };

    const output: FormInfo = {
        ls: '',
        ss: '',
        cid: '',
    };

    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('ls')) {
        output.ls = sessionStorage.getItem('ls');
    } else if (pageSource && pageSource.ls) {
        output.ls = pageSource.ls;
    } else {
        output.ls = '01 Website';
    }

    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('ss')) {
        output.ss = sessionStorage.getItem('ss');
    } else if (pageSource && pageSource.ss) {
        output.ss = pageSource.ss;
    } else if (secondarySource) {
        output.ss = secondarySource;
    } else {
        output.ss = 'C - Request Demo';
    }

    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('cid')) {
        output.cid = sessionStorage.getItem('cid');
    } else if (pageSource && pageSource.cid) {
        output.cid = pageSource.cid;
    } else if (cid) {
        output.cid = cid;
    } else {
        output.cid = '7014T000000kjn0QAA';
    }

    if (sourceInfo?.useGeoSpecificCid && formInfo?.enableGeoCIDs) {
        output.cid = formInfo.geoSpecific.filter((c) => c.country === user.location.country.name)[0].cid;
    }

    if (!paramKeys && urlParams) {
        urlParams.forEach((value, key) => {
            if (key === 'ls' || key === 'ss' || key === 'cid') {
                output[key] = value;
            }
        });
    }

    if (paramKeys && urlParams) {
        urlParams.forEach((value, key) => {
            if (key === 'ls' || key === 'ss' || key === 'cid' || paramKeys.includes(key)) {
                output[key] = value;
            } else {
                paramKeys.forEach((pkey) => {
                    if (isNonMatchingParamKey(pkey) && key === pkey.urlKey) {
                        output[pkey.salesforceKey] = value;
                    }
                });
            }
        });
    }

    return output;
};

export default formSources;
